module.exports = __webpack_public_path__ + "img/user_management.321f7134.svg";